import React from 'react';
import { Flex } from 'grid-styled';
import { Link, withRouter } from 'react-router-dom';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';

const BackToUS = ({ location }) => (
  <Link
    to={{
      pathname: location.pathname.match(/^(\/\w*)/)[1],
      search: location.search,
    }}
  >
    {/*HACK: mt to better align with text to the right*/}
    <Flex>
      <ArrowBack style={{ margin: '2px 8px 0 0' }} />
      Back to whole US
    </Flex>
  </Link>
);

export default withRouter(BackToUS);



// WEBPACK FOOTER //
// ./src/components/TitleBar/BackToUS.jsx